var positionActiveElement = [];
var positionMobileElement = [];
var lastSizeWindow = 0;
var activeContactPosition = 0;
var activeNewsPosition = 0;
var activeNewsYearPosition = 0;
var nNewsActive = 0;
var categoryNews = [];
var trans = require("./translations");

var allNews = [];

function filterNewsFun() {
  var beforeDate = '';
  var afterDate = '';
  var categoryNews = $('.product-navigator .category-news .active').data(
    'idcat'
  );

  var after =
    $('.news-year-query .active').data('after') != ''
      ? $('.news-year-query .active').data('after')
      : '';
  var before =
    $('.news-year-query .active').data('before') != ''
      ? $('.news-year-query .active').data('before')
      : '';
  if (after != '') {
    afterDate = new Date(after);
  }
  if (before != '') {
    beforeDate = new Date(before);
  }

  if (!allNews.length) {
    return;
  }
  filterNews = [];

  allNews.forEach(function(news) {
    if (afterDate != '' || beforeDate != '') {
      var dateNews = new Date(news.date);
    }
    if (dateNews && afterDate != '' && dateNews < afterDate) {
      console.log('News troppo vecchia');
      return;
    }
    if (dateNews && beforeDate != '' && dateNews > beforeDate) {
      console.log('News troppo Nuova');
      return;
    }
    if (categoryNews && categoryNews != news.acf.category.ID) {
      console.log('News Non in categoria');
      return;
    }
    filterNews.push(news);
  });

  publicNews(filterNews);
  return;
}
function checkIfQuerySetted() {
  console.log(
    $('.product-navigator .category-news .active').data('idcat'),
    $('.news-year-query .active').data('after'),
    $('.news-year-query .active').data('before')
  );
  if (
    $('.product-navigator .category-news .active').data('idcat') ||
    $('.news-year-query .active').data('after') ||
    $('.news-year-query .active').data('before')
  ) {
    return true;
  }
  return false;
}
function publicNews(arr, append) {
  var html = getHtmlNews(arr);
  console.log('aapned => ' + append);
  if (!append) {
    $('.news-category').html('');
  }
  $('.news-category').append(html);
  checkIfLoadMore(filterNews.length);
  filterNewsByCategory();
  if (!checkIfQuerySetted()) {
    filterNews = [];
  }
  if (filterNews.length < 6) {
    filterNews = [];
  } else {
    filterNews.splice(0, 6);
    console.log(filterNews);
  }
}
$(document).ready(function() {
  nNewsActive = 6;
  if ($('.product-navigator').length) {
    moveBoxToActive();
    lastSizeWindow = $(window).width();
  }
  $('.container-product-navigator').on('click tap', '.open .link', function(e) {
    e.preventDefault();
    console.log('Click On Active');
    if ($(this).data('link')) {
      window.location = $(this).data('link');
    }
  });
  if ($('#section-contact').length) {
    checkQueryObj();
    $('.box-product-navigator .box-category').on('click tap', function() {
      var $this = $(this);
      $('.product-navigator').removeClass('error');
      if ($(this).hasClass('active')) {
        return;
      }
      $('.box-product-navigator .box-category').each(function() {
        $(this).removeClass('active');
      });
      $this.addClass('active');
      moveBoxToActive();
      $('.product-navigator .father').removeClass('open');
      $('.product-navigator .father').css({
        top: 0,
        'max-height': '60px',
      });
    });
  }

  $('.category-news .box-category').on('click tap', function() {
    if (!allNews.length) {
      return;
    }

    var $this = $(this);
    if ($(this).hasClass('active')) {
      return;
    }
    $('.categories .box-category').each(function() {
      $(this).removeClass('active');
    });
    $this.addClass('active');
    moveBoxToActive('category');
    $('.product-navigator .father').removeClass('open');
    $('.product-navigator .father').css({
      top: 0,
      'max-height': '60px',
    });

    filterNewsFun();
  });
  $('.news-year-query .box-category').on('click tap', function() {
    if (!allNews.length) {
      return;
    }
    var $this = $(this);
    if ($(this).hasClass('active')) {
      return;
    }
    $('.news-year-query .box-category').each(function() {
      $(this).removeClass('active');
    });
    $this.addClass('active');
    moveBoxToActive('year');
    $('.product-navigator .father').removeClass('open');
    $('.product-navigator .father').css({
      top: 0,
      'max-height': '60px',
    });
    var after = $this.data('after');
    var before = $this.data('before');
    // if (after) {
    // 	filterNewsByYear(after, before);
    filterNewsFun();
    // 	return
    // } else {
    // 	filterNewsByYear(false);
    // }
    // var catId = $('.container .category-news .active').data('idcat');
    //
    // filterNewsByCategory(catId);
  });
});

$(window).resize(function() {
  if ($('.product-navigator').length && !$('#section-contact').length) {
    var nowSizeWindow = $(window).width();
    if (lastSizeWindow < 768 && nowSizeWindow >= 768) {
      triggerHover();
    }
    if (lastSizeWindow >= 768 && nowSizeWindow < 768) {
      triggerHover();
    }
    lastSizeWindow = nowSizeWindow;
    return;
  }
});
function moveBoxToActive(where) {
  var diff = 0;
  var productNavigatorOffset = $('.product-navigator').offset().top;
  $('.product-navigator .box-product-navigator').each(function() {
    if ($(this).children('.box-category.active').length) {
      var divActivePosition = $(this)
        .children('.box-category.active')
        .offset().top;
      if (where) {
        switch (where) {
          case 'year':
            console.log($(this).hasClass('news-year-query'));
            if (!$(this).hasClass('news-year-query')) {
              return;
            }
            break;
          case 'category':
            if (!$(this).hasClass('category-news')) {
              return;
            }
            break;
          default:
        }
      }
    } else {
      return;
    }
    var position = productNavigatorOffset - divActivePosition;
    if ($('#section-contact').length) {
      activeContactPosition = position;
    }
    if (where) {
      switch (where) {
        case 'year':
          activeNewsYearPosition = position;
          break;
        case 'category':
          activeNewsPosition = position;
          break;
        default:
      }
    }

    positionActiveElement.push(position);
    if ($(window).width() < 768) {
      var offset = $(this).offset().top;
      position = offset - divActivePosition;

      positionMobileElement.push(position);
    }
    $(this).css('top', position);
  });
}

$('.product-navigator .father').hover(
  function(e) {
    e.preventDefault();
    var index = parseInt($(this).data('index'));
    position = 0;

    $(this).css({
      top: position,
      'max-height': '2000px',
    });
    $(this)
      .children('.box-product-navigator')
      .css({
        top: 0,
      });
    $(this).addClass('open');
    var $this = $(this);
    setTimeout(function() {
      if (!$('#section-contact').length && !$('#news').length) {
        $this
          .children()
          .children('.active')
          .addClass('link');
      }
    }, 430);
  },
  function(e) {
    $(this).removeClass('open');
    var index = parseInt($(this).data('index'));
    var position = positionActiveElement[index];
    if ($(window).width() < 768) {
      position = positionMobileElement[index];
    }
    $(this)
      .children()
      .children('.active')
      .removeClass('link');

    $(this).css({
      top: 0,
      'max-height': '60px',
    });
    if (!$('#section-contact').length && !$('#news').length) {
      $(this)
        .children('.box-product-navigator')
        .css({
          top: position,
        });
      return;
    }
    if ($('#news').length) {
      if ($(this).hasClass('categories')) {
        $(this)
          .children('.box-product-navigator')
          .css({
            top: activeNewsPosition,
          });
        return;
      }
      if ($(this).hasClass('years')) {
        $(this)
          .children('.box-product-navigator')
          .css({
            top: activeNewsYearPosition,
          });
        return;
      }
    }
    if ($('#section-contact').length) {
      $(this)
        .children('.box-product-navigator')
        .css({
          top: activeContactPosition,
        });
    }
  }
);
function triggerHover() {
  $('.product-navigator .father').each(function() {
    $(this).removeClass('open');
    var index = parseInt($(this).data('index'));
    var position = positionActiveElement[index];
    if ($(window).width() < 768) {
      position = positionMobileElement[index];
    }
    $(this).css({
      top: 0,
      'max-height': '60px',
    });
    $(this)
      .children('.box-product-navigator')
      .css({
        top: position,
      });
  });
}
function checkQueryObj() {
  if (checkQueryUrl('prod')) {
    var lang = window.location.pathname.split('/')[1].toLowerCase();
    var prod = getParameterByName('prod');
		var prod = prod.replace(/[^a-zA-Z0-9]/g, '');
    var text = trans.subject_product_informations[lang] + ' ' + prod;
    // switch (lang) {
    //   case 'it':
    //     text = 'INFORMAZIONI PRODOTTTO ' + prod;
    //     break;
    //   case 'en':
    //     text = 'INFORMATIONS ABOUT PRODUCT ' + prod;
    //     break;
    //   default:
    // }
    var html =
      '<div class="box-category active" data-type="prod" data-prod="' +
      prod +
      '"><div class="name flex-col-center"><div class="flex-center"><div class="icon-row-product-navigator"></div><div class="flex-col-center"><span>' +
      text +
      '</span></div></div></div></div>';
    $('.parent-product-category .active').removeClass('active');
    $('.box-product-navigator').append(html);
    moveBoxToActive();
  }
}

function checkQueryUrl(field) {
  var url = window.location.href;
  if (url.indexOf('?' + field + '=') != -1) return true;
  else if (url.indexOf('&' + field + '=') != -1) return true;
  return false;
}
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function filterNewsByCategory(catId) {
  $('.news-category .news').each(function() {
    $(this)
      .fadeIn()
      .css('display', 'flex');
    $(this).removeClass('hidden-news');
    return;
  });
  setFocusNews();
}

function setFocusNews() {
  // var c = 0;
  // $('.news-category .news').each(function () {
  // 	if (c < 2 && !$(this).hasClass('hidden-news')) {
  // 		$(this).addClass('news-focus');
  // 		$(this).find('.big-news').removeClass('hide');
  // 		$(this).find('.small-news').addClass('hide');
  // 		$(this).find('.small-title-news').removeClass('small-title-news');
  // 		c++
  // 	} else {
  // 		if (!$(this).hasClass('hidden-news')) {
  // 			$(this).removeClass('news-focus');
  // 			$(this).find('.big-news').addClass('hide');
  // 			$(this).find('.small-news').removeClass('hide');
  // 			$(this).find('.title-box').addClass('small-title-news');
  // 		}
  // 	}
  // })
  // squareBoxNewsFocus()
}

var filterNews = [];
$(document).ready(function() {
  if ($('#news').length) {
    setTimeout(function() {
      // squareBoxNewsFocus()
    }, 200);
    $.get(
      'https://wp.primaautomotive.it/wp-json/wp/v2/news_category?per_page=300',
      function(data) {
        categoryNews = data;
      }
    );
    $.get(
      'https://wp.primaautomotive.it/wp-json/wp/v2/news?per_page=300',
      function(data) {
        allNews = data;
      }
    );
    $('#load-more').on('click tap', function() {
      if (!allNews.length) {
        return;
      }
      console.log('QUI');
      if (filterNews.length) {
        console.log('QUsssI');

        publicNews(filterNews);
        return;
      }

      if (!checkIfQuerySetted()) {
        console.log('no filter');

        var c = 0;
        var newsToAdd = [];
        allNews.forEach(function(news, index) {
          if (index < nNewsActive) {
            return;
          }
          if (c == 6) {
            return;
          }
          c++;
          newsToAdd.push(news);
        });
        console.log('Append => True');
        publicNews(newsToAdd, true);
        nNewsActive += c;
      }
    });
  }
});

$(window).on('resize', function() {
  // squareBoxNewsFocus()
});
// function squareBoxNewsFocus () {
// 	var height = $('.news-category .news-focus').width()
// 	$('.news-category .news').each(function() {
// 		if ($(this).hasClass('news-focus')) {
// 			if ($(window).width() < 768) {
// 				$(this).height('auto')
// 			} else {
// 				$(this).height(height)
// 			}
// 			return
// 		}
// 		if ($(window).width() < 768) {
// 			$(this).height('auto')
// 			return
// 		}
// 		$(this).height(height/2 + 50)

// 	})
// }

function checkIfLoadMore(length) {
  if (length >= 6) {
    $('.view-all-box').fadeIn();
    return true;
  }
  $('.view-all-box').fadeOut();
  return false;
}

function getHtmlNews(data, loadMore) {
  var lang = window.location.pathname.split('/')[1].toLowerCase();
  var html = '';
  var c = 0;
  data.forEach(function(news, index) {
    if (index > 5) {
      return;
    }
    var title = '';
    var text = '';
    var category = '';
    var titleUrl = '';
    switch (lang) {
      case 'it':
        var text = $(news.acf.text_it).text();
        // text = text.substr(0, 100) + '...'
        var contentIt = text.replace(/([\[\]])(?:(?=(\\?))\2.)*/g, '');
        contentIt = contentIt.substr(0, 120) + '...';
        lastIndex = contentIt.lastIndexOf(' ');
        contentIt = contentIt.substring(0, lastIndex) + '...';
        var titleIt = news.acf.title_it;
        if (titleIt.length > 65) {
          titleIt = titleIt.substr(0, 65);
          lastIndex = titleIt.lastIndexOf(' ');
          titleIt = titleIt.substring(0, lastIndex) + '...';
        }
        categoryNews.forEach(function(category) {
          if (category.id == news.acf.category.ID) {
            category = category.acf.name_it;
          }
        });
        title = titleIt;
        text = contentIt;
        titleUrl = news.acf.title_en
          .split(' ')
          .join('-')
          .toLowerCase();
        break;
      case 'en':
        var text = $(news.acf.text_en).text();
        // text = text.substr(0, 100) + '...'
        var contentEn = text.replace(/([\[\]])(?:(?=(\\?))\2.)*/g, '');
        contentEn = contentEn.substr(0, 120);
        lastIndex = contentEn.lastIndexOf(' ');

        categoryNews.forEach(function(cat) {
          if (cat.id == news.acf.category.ID) {
            category = cat.acf.name_en;
          }
        });
        contentEn = contentEn.substring(0, lastIndex) + '...';
        var titleEn = news.acf.title_en;

        if (titleEn.length > 65) {
          titleEn = titleEn.substr(0, 65);
          lastIndex = titleEn.lastIndexOf(' ');
          titleEn = titleEn.substring(0, lastIndex) + '...';
        }
        title = titleEn;
        text = contentEn;
        titleUrl = news.acf.title_en
          .split(' ')
          .join('-')
          .toLowerCase();
        break;
      default:
    }

    html +=
      '<div data-category="' +
      news.acf.category.ID +
      '" class="news flex-center hide ' +
      (index <= 2 && !loadMore ? '' : '') +
      '"> <div class="flex-col-center img-news-box"> <div style="background-image: url(' +
      news.acf.placeholder +
      ')" class="img-news"></div></div><div class="info-news-box flex-col-space-around"> <div class="title flex-col-start"> <div class="title-box flex-col-space-between ' +
      (index < 2 && !loadMore ? 'small-title-news' : 'small-title-news') +
      '"><span>' +
      title +
      '</span> <div class="big-news ' +
      (index <= 2 && !loadMore ? 'hide' : 'hide') +
      '"> <div class="flex-space-between"> <a href="" class="cat-link hidden-mobile ipad desktop"><span class="black second-title">' +
      category +
      '</span></a><a href="/' +
      lang +
      '/news/' +
      news.id +
      '/' +
      titleUrl +
      '" class="read-more">READ MORE</a> </div></div></div></div><div class="small-news ' +
      (index > 2 && !loadMore ? '' : '') +
      '"> <div class="margin-bot-15"><span class="second-title">' +
      text +
      '</span></div></div><div class="small-news ' +
      (index > 2 && !loadMore ? '' : '') +
      '"><a href="/' +
      lang +
      '/news/' +
      news.id +
      '/' +
      titleUrl +
      '">READ MORE</a></div></div></div>';
    c++;
  });
  nNewsActive = c;
  return html;
}



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_product-navigator.js
// module id = 13
// module chunks = 0